






































import { Component, Mixins, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { ImelessTextarea } from "../../system";
import { BrowserUtility, BrowserKinds } from "../../../utilities";

@Component({
  components: {
    ImelessTextarea,
  },
})
export default class DocumentManageNumberInputArea extends Mixins(ModelEditableMixin) {
  $refs!: {
    firstInputSectionImelessTextarea: ImelessTextarea,
    firstInputSectionInput: HTMLInputElement,
  };

  get manageNumberText(): string {
    return this.editingSource
      ? this.editingSource
      : "";
  }

  set manageNumberText(value: string) {
    this.input(value);
  }
  
  get firstSection(): string {
    return this.getSectionValue(0);
  }

  set firstSection(value: string) {
    this.setSectionValue(0, value);
  }

  get secondSection(): string {
    return this.getSectionValue(1);
  }

  set secondSection(value: string) {
    this.setSectionValue(1, value);
  }

  get thirdSection(): string {
    return this.getSectionValue(2);
  }

  set thirdSection(value: string) {
    this.setSectionValue(2, value);
  }
  
  get fourthSection(): string {
    return this.getSectionValue(3);
  }

  set fourthSection(value: string) {
    this.setSectionValue(3, value);
  }

  get shouldUseImelessTextarea(): boolean {
    return (BrowserUtility.getBrowserKind() !== BrowserKinds.InternetExplorer)
        && !BrowserUtility.isMobile();
  }

  setSectionValue(index: number, value: string) {
    const splitted = this.manageNumberText.split("-");
    splitted[index] = value;
    this.manageNumberText = this.generateManageNumberText(splitted, 4);
  }

  generateManageNumberText(values: string[], sectionCount: number): string {
    const extracted: string[] = [];
    for (let index = 0; index < sectionCount; ++index) {
      const replaced = (values[index] != null)
        ? values[index].replace(/[^0-9]/g, "")
        : "";
      extracted[index] = !!replaced
        ? replaced
        : "＊";
    }
    return extracted.join("-");
  }

  getSectionValue(index: number): string {
    const splitted = this.manageNumberText.split("-");
    const value = splitted[index];
    return !!value
      ? value.replace(/[^0-9]/g, "")
      : "";
  }

  @Emit()
  onEnterKeyDown(): void {}

  focusToFirstInputSection(): void {
    if (!this.$refs.firstInputSectionImelessTextarea && !this.$refs.firstInputSectionInput) {
      return;
    }
    if (this.shouldUseImelessTextarea) {
      this.$refs.firstInputSectionImelessTextarea.getEditor().focus();
    } else {
      this.$refs.firstInputSectionInput.focus();
    }
  }
}
